import { AsyncStateStatus } from '../root.types'

/**
 * <h5> </h5>
 * @typedef AuthTypes
 * @namespace AuthTypes
 * @category React
 * @subcategory Redux / Types
 */

/**
 * Typing constant of action identifiers.
 * </br>
 * The action identifiers are:
 * <pre>
 *     <ul>
 *         <li>@auth/loginReset</li>
 *         <li>@auth/loginRequest</li>
 *         <li>@auth/loginSuccess</li>
 *         <li>@auth/loginFailure</li>
 *      </ul>
 * </pre>
 * @memberof AuthTypes
 * @function
 * @category React
 * @subcategory Redux / Types
 */
export enum AuthTypes {
    LOGIN_RESET = '@auth/loginReset',
    LOGIN_REQUEST = '@auth/loginRequest',
    LOGIN_SUCCESS = '@auth/loginSuccess',
    LOGIN_FAILURE = '@auth/loginFailure',
    REPLACE_PASSWORD = '@auth/replacePassword',
    FORGOT_PASSWORD = '@auth/forgotPassword',
    LOGIN_TFA = '@auth/loginTfa',
    SETUP_TFA = '@auth/setupTfa'
}


/**
 * @memberof AuthTypes
 * @interface
 * @category React
 * @subcategory Redux / Types
 * @property {string} login Auth data login.
 * @property {string} password Auth data password.
 */
export interface IActionAuth {
    readonly login: string
    readonly password?: string
    readonly code?: string
}


export interface IActionFirstLogin {
    readonly email?: string
    readonly password?: string
    readonly new_password?: string
    readonly repeat_new_password?: string
    readonly token?: string
}

export interface IActionSignup {
    readonly name: string | undefined,
    readonly email: string | undefined,
    readonly cpf: string | undefined,
    readonly organization_id: string | undefined,
    readonly institutional_position: string | undefined,
    readonly institutional_registration: string | undefined,
    readonly phone: string | undefined,
}

/**
 * @memberof AuthTypes
 * @interface
 * @category React
 * @subcategory Redux / Types
 * @property {AsyncStateStatus} status
 */
interface ILoginState {
    status: AsyncStateStatus
}

interface ITfaSetupState {
    status: AsyncStateStatus
    data: any
}


/**
 * @memberof AuthTypes
 * @interface
 * @category React
 * @subcategory Redux / Types
 * @property {ILoginState} login
 */
export interface AuthState {
    login: ILoginState
    replace: ILoginState
    forgot: ILoginState
    loginTfa: ILoginState
    setupTfa: ITfaSetupState
}
